module.exports = __webpack_public_path__ + "img/HCIS_redraw.971c9d61.png";